import { configureStore } from '@reduxjs/toolkit'
import navReducer from './features/nav/navSlice'
import authReducer from './features/auth/authSlice'
import logoutReducer from './features/logout/logoutSlice'

export const store = configureStore({
  reducer: {
    nav: navReducer,
    auth : authReducer,
    logout : logoutReducer
  },
})
